import { Panel } from 'rsuite';
import { SIDEBAR_WIDTH } from '@/map/map-constants';
import styled from 'styled-components';

export const SectionPanel = styled(Panel)`
  width: ${SIDEBAR_WIDTH}px;

  .rs-panel-heading {
    padding: 14px 24px;

    :before {
      top: 14px;
      right: 23px;
      color: rgba(0, 0, 0, 0.5);
    }
  }

  .rs-panel-title {
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    color: #101938;
    height: 14px;

    > span {
      :after {
        content: '${(props) => props.appliedfilterscount}';
        display: inline-block;
        line-height: 1.3;
        text-align: center;
        color: rgba(0, 0, 0, 0.5);
        width: 18px;
        height: 18px;
        margin-left: 6px;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.1);
        opacity: ${(props) => (props.appliedfilterscount ? 1 : 0)};
      }
    }
  }

  .rs-panel-body {
    padding-top: 0 !important;
    padding-left: 24px;
    padding-bottom: 0 !important;
  }
`;

// eslint-disable-next-line
const ClosedEye = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' aria-hidden='true' focusable='false' width='1em' height='1em' style='-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);' preserveAspectRatio='xMidYMid meet' viewBox='0 0 1024 1024'%3E%3Cpath d='M508 624a112 112 0 0 0 112-112c0-3.28-.15-6.53-.43-9.74L498.26 623.57c3.21.28 6.45.43 9.74.43zm370.72-458.44L836 122.88a8 8 0 0 0-11.31 0L715.37 232.23Q624.91 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.7 119.43 136.55 191.45L112.56 835a8 8 0 0 0 0 11.31L155.25 889a8 8 0 0 0 11.31 0l712.16-712.12a8 8 0 0 0 0-11.32zM332 512a176 176 0 0 1 258.88-155.28l-48.62 48.62a112.08 112.08 0 0 0-140.92 140.92l-48.62 48.62A175.09 175.09 0 0 1 332 512z' fill='%2337A3BC'/%3E%3Cpath d='M942.2 486.2Q889.4 375 816.51 304.85L672.37 449A176.08 176.08 0 0 1 445 676.37L322.74 798.63Q407.82 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z' fill='%2337A3BC'/%3E%3C/svg%3E")`;
// eslint-disable-next-line
const OpenEye = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' aria-hidden='true' focusable='false' width='1em' height='1em' style='-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);' preserveAspectRatio='xMidYMid meet' viewBox='0 0 1024 1024'%3E%3Cpath d='M396 512a112 112 0 1 0 224 0a112 112 0 1 0-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3c7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176s176 78.8 176 176s-78.8 176-176 176z' fill='%2337A3BC'/%3E%3C/svg%3E");`;

export const StandAloneSection = styled(SectionPanel)`
  .rs-panel-title > span:after {
    height: unset;
  }

  .rs-panel-heading {
    :before {
      transform: unset;
      -webkit-transform: unset;
      content: ${(props) => (props.isfilterselected ? OpenEye : ClosedEye)};
      right: 20px;
    }
  }
`;

const SwitchRow = styled.div`
  display: flex;
  height: 14px;
  align-items: center;
`;

export const MasterSwitchWrapper = styled.div`
  display: flex;
  height: 14px;
  align-items: center;
  margin-top: 23px;
`;

export const SwitchWrapper = styled(SwitchRow)`
  cursor: pointer;

  .upside-down {
    transform: rotate(180deg);
    transition: transform 400ms;
  }

  .down-upside {
    transform: rotate(0deg);
    transition: transform 400ms;
  }
`;

export const IconSizer = styled(SwitchRow)`
  height: 12px;
  width: 12px;
`;

export const SwitchName = styled(SwitchRow)`
  margin-left: 6px;
`;

export const Spacer = styled(SwitchRow)`
  width: ${(props) => props.width || 29}px;
  height: ${(props) => props.height || 14}px;
`;
